import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { Subscription } from 'rxjs';
import { PageGroupEditComponent } from '../page-group-edit/page-group-edit..component';
import { QrveyService } from '../../../../../../core/lists/_services/qrvey.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-page-group-list',
  templateUrl: './page-group-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageGroupListComponent implements OnInit, OnDestroy {
  dataSource: any;
  displayedColumns = ['name', 'pages', 'actions'];
  private subscriptions: Subscription[] = [];
  appId = null;

  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private qrveyService: QrveyService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.app_id) {
        this.appId = params.app_id;
        this.loadData();
      }
    });
  }

  loadData() {
    this.subscriptions.push(
      this.qrveyService.getPageGroups(this.appId).subscribe((res) => {
        this.dataSource = res.data;
        this.cdr.detectChanges();
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  deletePageGroups(_item) {
    const _title = 'Delete Page Group';
    const _description = 'Are you sure you want to delete Page Group?';
    const _waitDescription = 'Deleting...';

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDescription);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.qrveyService.deletePageGroup(_item, this.appId).subscribe(() => {
        this.loadData();
      });
    });
  }

  editPageGroup(_item) {
    const dialogRef = this.dialog.open(PageGroupEditComponent, {
      data: { mode: 'UPDATE', _item, appId: this.appId },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadData();
    });
  }

  createPageGroup() {
    const dialogRef = this.dialog.open(PageGroupEditComponent, {
      data: { mode: 'CREATE', appId: this.appId },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadData();
    });
  }
}
